module.exports = __webpack_public_path__ + "img/photo-3.d6cf2c5a.jpg";